<template>
    <section class="card card-info card-outline mb-4" role="region">
        <template v-if="station.enable_streamers">
            <div class="card-header">
                <h3 class="card-title">
                    Streamers/DJs
                    <small class="badge badge-pill badge-success">Enabled</small>
                </h3>
            </div>
            <div class="card-body">
            <div class="card-actions" v-if="userCanManageStreamers || userCanManageProfile">
                <a class="btn btn-outline-info btn-sm" v-if="userCanManageStreamers" :href="streamersViewUri">
                    <i class="fas fa-cog"></i>
                    Manage
                </a>
                  <button :disabled="processing" @click.prevent="toggleStreamers" class="btn btn-outline-success btn-sm">
                     <i class="fas fa-times"></i>
                     {{processing? 'disabling...':'Disable'}}
                </button>
            </div>
            </div>
        </template>
        <template v-else>
            <div class="card-header">
                <h3 class="card-title">
                    Streamers/DJs
                    <small class="badge badge-pill badge-danger">Disabled</small>
                </h3>
            </div>
            <div class="card-body">
            <div class="card-actions" v-if="userCanManageProfile">
                  <button :disabled="processing" @click.prevent="toggleStreamers" class="btn btn-outline-success btn-sm">
                    <i class="fas fa-check"></i>
                     {{processing? 'enabling...':'Enable'}}
                </button>
            </div>
            </div>
        </template>
    </section>
</template>

<script>

export default {
    
    data(){
        return  {
        userCanManageProfile: true,
        userCanManageStreamers: true,
        streamersViewUri: '!#',
        streamToggleUri: 'admin/station/streamers',
        processing: false
    }
    },

        methods: {
           toggleStreamers(){
               this.processing = true
            axios.post(this.streamToggleUri).then( (res) => {
                this.$store.commit('updateStation', res.data)
                this.processing = false
        })
    }
}
};
</script>
